import { clamp } from 'utils/math';

export function visibleRatio(elem) {
	if (!elem) return;

	const rect = elem.getBoundingClientRect();
	const windowHeight = window.innerHeight;

	const visibleTop = clamp(rect.top, 0, windowHeight);
	const visibleBottom = clamp(rect.bottom, 0, windowHeight);

	return Math.abs(visibleBottom - visibleTop) / Math.min(rect.height, windowHeight);
}

export function isScrolledIntoView(elem) {
	if (!elem) return;
	return visibleRatio(elem) > .5;
}

export function getPercentageThreshold(offsetTop) {
	if (typeof window === 'undefined' || !offsetTop) {
		return 0;
	}
	return offsetTop / window.innerHeight + 0.01;
}

export function closestToCenter(elements) {
	let goal = window.innerHeight * .5;
	let prevDist = Infinity;
	for (let i = 0; i < elements.length; i++) {
		const rect = elements[i].getBoundingClientRect();
		let dist = Math.max(rect.top - goal, goal - rect.bottom);
		if (dist <= 0) {
			return elements[i];
		}
		if (dist >= prevDist) {
			return elements[i - 1];
		}
		prevDist = dist;
	}
	return null;
}

export function isSectionUnderHeader(elem) {
	if (!elem) return;
	const rect = elem.getBoundingClientRect();
	return (rect.top <= 25 && rect.bottom > 25);
}
